import React, { useEffect, useState } from "react";
import { getAthleteFundamentalsReport } from "../../services/api";

const fundamentosLabels = {
  S: "Saque",
  R: "Recepção",
  E: "Levantamento",
  A: "Ataque",
  B: "Bloqueio",
  D: "Defesa",
  // F: "Falta",
};

const qualidadeLabels = {
  S: ["Ponto", "Muito bom", "Bom", "Ruim", "Muito ruim", "Erro"],
  R: ["Excelente", "Muito bom", "Bom", "Ruim", "Muito ruim", "Erro"],
  D: ["Excelente", "Muito bom", "Bom", "Ruim", "Muito ruim", "Erro"],
  E: ["Ponto", "Muito bom", "Bom", "Ruim", "Muito ruim", "Erro"],
  A: ["Ponto", "Muito bom", "Bom", "Ruim", "Muito ruim", "Erro"],
  B: ["Ponto", "Muito bom", "Bom", "Ruim", "Muito ruim", "Erro"],
  // F: ["_", "_", "_", "_", "_", "Erro"],
};

const qualidades = ["#", "+", "!", "-", "/", "="];

export default function ScoutAthleteFundamentalsReport({
  partida,
  teamNames,
  teams,
}) {
  const [selectedTeam, setSelectedTeam] = useState("home");
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!partida || !selectedTeam) return;
    setLoading(true);
    setError("");
    getAthleteFundamentalsReport(partida, selectedTeam)
      .then((res) => {
        setData(res.data.athletes || []);
        setLoading(false);
      })
      .catch((err) => {
        setError("Erro ao buscar relatório");
        setLoading(false);
      });
  }, [partida, selectedTeam]);

  // Função para somar totais de cada linha
  const getRowTotal = (ath, f) => {
    return qualidades.reduce((sum, q) => {
      const val = ath[f][q];
      return sum + (val !== "-" ? Number(val) : 0);
    }, 0);
  };

  // Função para estilizar abas
  const tabClass = (active) =>
    `px-4 py-2 rounded-t-md font-semibold cursor-pointer select-none border-b-2 ${
      active
        ? "border-blue-600 text-blue-700 bg-white"
        : "border-grey-200 text-gray-500 hover:border-blue-200"
    }`;

  // Função para zebra
  const zebra = (idx) => (idx % 2 === 1 ? "bg-gray-50" : "");
  // Função para célula de hífen
  const hyphenCell = (val) =>
    val === "-" ? "text-gray-300 text-gray-400" : "";

  return (
    <div className="bg-base-100 p-4 rounded-lg shadow-md fundamentals-report">
      {/* Abas de seleção de time */}
      <div className="mb-4 flex items-center gap-2 border-b">
        <div
          className={tabClass(selectedTeam === "home")}
          onClick={() => setSelectedTeam("home")}
        >
          {typeof teamNames?.home === "string"
            ? teamNames.home
            : teamNames?.home?.name || "Home"}
        </div>
        <div
          className={tabClass(selectedTeam === "away")}
          onClick={() => setSelectedTeam("away")}
        >
          {typeof teamNames?.away === "string"
            ? teamNames.away
            : teamNames?.away?.name || "Away"}
        </div>
      </div>
      {loading ? (
        <div className="text-center">Carregando...</div>
      ) : error ? (
        <div className="text-red-500">{error}</div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {Object.keys(fundamentosLabels).map((f) => (
            <div key={f} className="overflow-x-auto">
              <h3 className="font-bold text-lg mb-2 text-center">
                {fundamentosLabels[f]}
              </h3>
              <table className="table table-sm w-full border border-base-300">
                <thead>
                  <tr>
                    <th className="border border-base-300">Nº</th>
                    <th className="border border-base-300">Nome</th>
                    {qualidades.map((q, idx) => (
                      <th
                        key={q}
                        className="border border-base-300"
                        title={qualidadeLabels[f][idx]}
                      >
                        {q}
                      </th>
                    ))}
                    <th className="border border-base-300">Total</th>
                  </tr>
                </thead>
                <tbody>
                  {data.map((ath, idx) => (
                    <tr key={ath.number} className={zebra(idx)}>
                      <td className="border border-base-300 text-center">
                        {ath.number}
                      </td>
                      <td className="border border-base-300">
                        {typeof ath.name === "string"
                          ? ath.name
                          : ath.name && typeof ath.name.name === "string"
                          ? ath.name.name
                          : ""}
                      </td>
                      {qualidades.map((q) => (
                        <td
                          key={q}
                          className={`border border-base-300 text-center ${hyphenCell(
                            ath[f][q]
                          )}`}
                        >
                          {ath[f][q]}
                        </td>
                      ))}
                      <td className="border border-base-300 text-center font-bold">
                        {getRowTotal(ath, f)}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
